const content: { [key: string]: any } = {
  title: {
    pageTitle: "Renewal Action Report",
    pageDescription:
      "This report provides a list of ABOs in your group who are due for renewal this month, currently in their grace period, and indicates whether they are enrolled in auto-renewal or not.",
  },
  tabs: {
    notOnAuto: "Not on Auto Renewal",
    onAuto: "On Auto Renewal",
    inRenewalPeriod: "In Renewal Period",
    inGracePeriod: "In Grace Period",
    earlyRenewalPeriod: "In Early Renewal Period",
  },
  filter: {
    groupLeader: {
      allOption: "All ABOs",
    },
  },
  export: {
    button: "Export",
    title: "Export Report",
    description: "This Report will include a list of ABOs on their last month to renew their business.",
  },
  customerAboNumber: "Customer/ABO Number",
  losTreeView: "LOS Tree View",
  table: {
    columns: {
      aboName: "ABO Name / Number",
      ppv: "PPV",
      ppvYtd: "PPV YTD",
      gpv: "GPV",
      sponsoring: "Sponsoring",
      sponsoringYtd: "Annual Sponsoring",
      groupSize: "Group Size",
      customers: "Customers",
      autoRenewal: "Auto Renewal",
      watchlist: "Watchlist",
      bonus: "Bonus %",
      customerPv: "Customer PV",
      sponsorName: "Sponsor Name",
      pointsToNextLevel: "Points to Next Level",
      nonVcs: "Non VCS PV",
      gbv: "GBV",
      frontlines: "Frontlines",
      rubyPv: "Ruby PV",
      renewalDate: "Renewal Date",
      expirationDate: "Expiration Date",
      qualifiedLegs: "Qualified Legs",
      vcs: "VCS %",
      annualPPV: "Annual PPV",
    },
  },
} as const;

export default content;
